import * as graphql from '@treams/treams-network';

export function feedbackQuestionLevels(
	question: graphql.FeedbackRequestQuestion,
): graphql.CompetencyLevelOption[] {
	if (question.competencyLevelSet) {
		return question.competencyLevelSet.levels.map((level) => ({
			level,
			criteria: null,
			enabled: true,
		}));
	}

	return question.competency?.levels ?? [];
}
